import { render } from "./SearchFormDynamicDateRange.vue?vue&type=template&id=9c96c5c8&scoped=true"
import script from "./SearchFormDynamicDateRange.vue?vue&type=script&lang=ts"
export * from "./SearchFormDynamicDateRange.vue?vue&type=script&lang=ts"

import "./SearchFormDynamicDateRange.vue?vue&type=style&index=0&id=9c96c5c8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-9c96c5c8"

export default script